import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { api } from "../../api/client";
import { endpoints } from "../../api/endpoints";
import type { CalendarPreview, CalendarProfiles } from "../../types/directory";

export function useCalendarProfiles() {
  return useQuery({
    queryKey: ["calendar-profiles"],
    queryFn: async () => {
      const { data } = await api.get<CalendarProfiles>(endpoints.calendar.profiles());
      return data;
    },
  });
}

export function useCalendarPreview(calendarId: number | null) {
  return useQuery({
    queryKey: ["calendar-preview", calendarId],
    queryFn: async () => {
      const { data } = await api.get<CalendarPreview>(
        endpoints.calendar.preview(String(calendarId)),
      );
      return data;
    },
    enabled: calendarId !== null,
  });
}

/** approved gates publishing; sync_enabled false is what "delete" does here. */
export function useUpdateCalendar() {
  const client = useQueryClient();
  return useMutation({
    mutationFn: async ({
      calendarId,
      patch,
    }: {
      calendarId: number;
      patch: { approved?: boolean; sync_enabled?: boolean };
    }) => {
      const { data } = await api.put(endpoints.calendar.update(String(calendarId)), patch);
      return data;
    },
    onSuccess: () => client.invalidateQueries({ queryKey: ["calendar-profiles"] }),
  });
}
